
     import Vue from 'vue';
     export default {
       scrollToTop: true,
       head() {
         return {
           title: this.title,
           meta: [{
               hid: 'og:title',
               property: 'og:title',
               content: this.title
             },
             {
               hid: 'twitter:title',
               property: 'twitter:title',
               content: this.title
             },
             {
            hid: 'description',
            name: 'description',
            content:'Explore the full lyrics of Aarti "Shri Rama Chandra Kripalu Bhajuman" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full lyrics of Aarti "Shri Rama Chandra Kripalu Bhajuman" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shri Rama Chandra Kripalu Bhajuman Aarti, Ram Aarti, Lord Rama Bhajan, Ram Chandra Kripalu Bhajuman lyrics'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Shri Rama Chandra Kripalu Bhajuman Aarti, Ram Aarti, Lord Rama Bhajan, Ram Bhakti, Ram worship, Ram Chandra Kripalu Bhajuman lyrics, Shri Ram Aarti in Hindi, Ram Bhajan lyrics, Ayodhya Ram Aarti, Ramayana Aarti, Spiritual Aarti, Lord Rama prayer, Ram Navami Aarti, Shri Ramchandra Aarti, devotional aarti, Shri Ram Aarti lyrics in Hindi, श्री राम चंद्र कृपालु भजमन, Shree Ram Chandra Kripalu Bhajman Lyrics, Shree Ram Chandra Kripalu Bhajman Lyrics in english, Shree Ram Chandra Kripalu Bhajman Lyrics in english'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/ram.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/ram.webp'
          },
           ],
         }
       },
     
         components: {
      },
      data() {
        return {
          title:'Shri Rama Chandra Kripalu Bhajuman | Ramachandrachi Aarti - श्री रामचन्द्र कृपालु भजु मन (रामचन्द्रजीची आरती)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/ram"
        },
        "headline": "Shri Rama Chandra Kripalu Bhajuman - श्री रामचन्द्र कृपालु भजु मन (रामचन्द्रजीची आरती)",
        "name" : "Shri Rama Chandra Kripalu Bhajuman - Ramachandrachi Aarti",
        "description": "Explore the full lyrics of Aarti 'Shri Rama Chandra Kripalu Bhajuman' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/ram.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
      changeLanguage:function () {
        this.langauageMarathi = !this.langauageMarathi
      }
    }
  
    }
  